import { useEffect, useState } from "react"
import { FaPen } from "react-icons/fa"
import styled from "styled-components"
import { SearchDropdown } from "@prosolve/common-components-ui"
import AccountDropdown from "../../Shared/AccountDropdown"
import ImplementationSelector from "../../Shared/ImplementationSelector"
import OpportunityDropdown from "../../Shared/OpportunityDropdown"
import ShippingModal from "../../Shared/ShippingModal"
import useFetchOrders from "../../Shared/useFetchOrders"
import useShipmentSnackbar from "../../Shared/useShipmentSnackbar"
import OptionalFormFieldWrapper from "../../Shared/OptionalFormFieldWrapper"

const Row = styled.div`
  display: flex;
  gap: 15px;
`

const SectionRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-bottom: 20px;
`

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;

  padding: 15px;
  //border: solid 1px rgb(2 128 198 / 50%);
  //border: solid 1px rgb(0 0 0 / 10%);
  border-top: solid 3px rgb(2, 128, 198);
  border-left: solid 1px rgb(0 0 0 / 10%);
  border-right: solid 1px rgb(0 0 0 / 10%);
  border-bottom: solid 1px rgb(0 0 0 / 10%);
  border-radius: 10px;
  box-shadow: 2px 2px 5px rgb(0 0 0 / 10%);
  background: rgba(0, 0, 0, 0.01);
`

const SectionHeader = styled.div`
  color: gray;

  //border-bottom: solid 1px #0280c6;
`

export function AssignAccountModal ({
  orderEx,
  onClose,
  onChange
}) {
  const [accountId, setAccountId] = useState()
  const [opportunityId, setOpportunityId] = useState()
  const [opportunity, setOpportunity] = useState()
  const [implementationId, setImplementationId] = useState()

  const [isBusy, setIsBusy] = useState()
  const [validationMessage, setValidationMessage] = useState()

  const [isReloadImplementation, setIsReloadImplementation] = useState(0)
  const [isReloadOpportunity, setIsReloadOpportunity] = useState(0)

  const { fetchCreateOrder } = useFetchOrders()
  const { shipmentSnackbar } = useShipmentSnackbar()

  const warning = ''+
`To prevent misuse, this operation can only be used once. 
After an account, implementation, or opportunity is submitted, this feature will no longer be available for this order.`

  const validate = () => {
    const formAccountId = accountId || opportunity?.AccountId
    const formData = {
      _id: orderEx.data?._id,
      accountId: formAccountId,
      opportunityId,
      implementationId,
      shipbobOrderId: orderEx.dataSb?.id,
      isRefreshOpportunity: true
    }
    const isValid = Boolean(formAccountId)
    if (!isValid) {
      setValidationMessage('Please select at least an account or opportunity to proceed')
    }
    return [formData, isValid]
  }

  // TODO NOTE, during this operation, the draft order MAY OR MAY NOT EXIST YET (if created directly in ShipBob)
  const editOrder = async (formValues) => {
    setIsBusy(true)
    try {
      const jsonData = await fetchCreateOrder({ formValues })

      onChange(jsonData, true)
      onClose()
      
    } catch (e) {
      console.error(e)
      shipmentSnackbar.newMessage({ message: 'Error updating order', severity: 'failure' })
    }
    setIsBusy(false)
  }

  const onAccountChange = (val) => {
    setAccountId(val)
    setImplementationId()
    setOpportunityId()
    setIsReloadImplementation(1)
    setIsReloadOpportunity(1)
    setValidationMessage()
  }

  const onOpportunityChange = (val, data) => {
    setOpportunityId(val)
    setOpportunity(data.opportunity)
    setValidationMessage()
  }

  const onSubmit = () => {
    const [formValues, isValid] = validate()
    if (!isValid) return

    // eslint-disable-next-line no-restricted-globals
    if (!confirm(`${warning}\n\nAre you ready to submit the changes?`)) return

    editOrder(formValues)
  }

  useEffect(() => {
    if (isReloadImplementation) {
      setIsReloadImplementation(0)
    }
    if (isReloadOpportunity) {
      setIsReloadOpportunity(0)
    }
  }, [isReloadImplementation, isReloadOpportunity])

  return (
    <ShippingModal title={"Assign Account"} isBusy={isBusy} onClose={onClose} onSubmit={onSubmit}>
      <SectionRoot>
        <Section>
          <SectionHeader>Account</SectionHeader>
          <Row>
            <AccountDropdown value={accountId} onChange={onAccountChange} />
            {isReloadImplementation !== 1
              ? <ImplementationSelector accountId={accountId} value={implementationId} onChange={(val) => setImplementationId(val)} />
              : <OptionalFormFieldWrapper isEnabled={true} label={'Implementation'}>
                  <SearchDropdown options={[]} maxHeight='200px' width='350px' />
                </OptionalFormFieldWrapper>
            }
          </Row>
          <Row>
            {isReloadOpportunity !== 1
              ? <OpportunityDropdown accountId={accountId} value={opportunityId} onChange={onOpportunityChange} />
              : <OptionalFormFieldWrapper isEnabled={true} label={'Opportunity'}>
                  <SearchDropdown options={[]} maxHeight='200px' width='350px' />
                </OptionalFormFieldWrapper>
            } 
          </Row>
          {validationMessage && (
            <Row>
              <div style={{ color: 'red' }}>
                {validationMessage}
              </div>
            </Row>
          )}
        </Section>
        <Section>
        <SectionHeader>Warning</SectionHeader>
        <Row>
          {warning}
        </Row>
        </Section>
      </SectionRoot>
    </ShippingModal>
  )

}

export default function AssignAccountButton ({
  orderEx,
  onChange
}) {
  const [isOpen, setIsOpen] = useState()

  const onClose = () => {
    setIsOpen(false)
  }

  const onClick = () => {
    setIsOpen(true)
  }

  return (
    <>
      {isOpen &&
        <AssignAccountModal orderEx={orderEx} onClose={onClose} onChange={onChange} />
      }
      <FaPen onClick={onClick} style={{ fontSize: '0.7em', cursor: 'pointer' }} />
    </>
  )

}